export function hero() {
  const videoFullscreenWrapper = document.querySelector('.hero__fullvideo-wrapper');
  const videoFullscreen = document.querySelector(':is(.hero, .hero-case-study) .hero__fullvideo-wrapper video');
  const openVideoBtn = document.querySelector('.video-open .wp-element-button');
  const closeVideoBtn = document.querySelector('.video-close .wp-element-button');
  
  if (!openVideoBtn) {
    return;
  }

  openVideoBtn.addEventListener('click', function() {
    videoFullscreenWrapper.classList.add('hero__fullvideo-wrapper--open');
    videoFullscreen.play(); // Play the video
  })
  
  if (!closeVideoBtn) {
    return;
  }

  closeVideoBtn.addEventListener('click', function() {
    videoFullscreenWrapper.classList.remove('hero__fullvideo-wrapper--open');
    videoFullscreen.pause(); // Pause the video
    videoFullscreen.currentTime = 0; // Reset the video playback position to the beginning
  })

  const scrollDown = document.querySelector('.hero__scrolldown');
  if (!!scrollDown) {
    scrollDown.addEventListener('click', () => {
      const hero = scrollDown.closest(':is(.hero, .hero-case-study)');
      if (!!hero) {
        hero.nextElementSibling.scrollIntoView( { behavior: 'smooth' } );
      }
    })
  }
}